module.exports = __webpack_public_path__ + "static/img/no2.bdc3b611.png";